// Guard the whole module (prevents double-run if enqueued twice)
if (!document.documentElement.dataset.homeJsInit) {
	document.documentElement.dataset.homeJsInit = '1';

	window.addEventListener('DOMContentLoaded', () => {
		const home = document.querySelector('.home');
		if (!home) return;

		// ----- FADE IN HERO TEXT -----
		const title = document.querySelectorAll('[data-anim-title] span');
		const subtitle = document.querySelector('[data-anim-subtitle]');

		title.forEach((elem, i) => {
			setTimeout(() => {
				elem.classList.add('show');
				if (i === title.length - 1 && subtitle)
					subtitle.classList.add('show');
			}, i * 100);
		});

		// ----- MOUSEMOVE PARALLAX (bind once globally) -----
		if (!document.documentElement.dataset.parallaxBound) {
			document.documentElement.dataset.parallaxBound = '1';
			document.addEventListener(
				'mousemove',
				function parallax(e) {
					// Only move elements on pages that actually have layers
					const layers = document.querySelectorAll('.layer');
					if (!layers.length) return;
					layers.forEach((layer) => {
						const speed = parseFloat(
							layer.getAttribute('data-speed') || '0'
						);
						const y = (window.innerHeight - e.pageY * speed) / 100;
						const x = (window.innerWidth - e.pageX * speed) / 100;
						layer.style.transform = `translateX(${x}px) translateY(${y}px)`;
					});
				},
				{ passive: true }
			);
		}

		// ----- GSAP / PLUGINS (register once) -----
		// Relaunch pages have no guide-line or lottie targets, so functions.php does not
		// enqueue GSAP/Lottie there; everything below depends on them.
		if (typeof gsap === 'undefined') return;
		if (!document.documentElement.dataset.gsapPlugins) {
			document.documentElement.dataset.gsapPlugins = '1';
			gsap.registerPlugin(
				ScrollTrigger,
				DrawSVGPlugin,
				MorphSVGPlugin,
				MotionPathPlugin
			);
			gsap.defaults({ ease: 'none' });
		}

		// ----- LINE ANIMATION (per-element guard) -----
		document.querySelectorAll('[data-guide] svg').forEach((elem) => {
			if (elem.dataset.guideInit) return;
			elem.dataset.guideInit = '1';

			const star = elem.querySelector('.star');
			const line = elem.querySelector('.line');
			if (!star || !line) return;

			gsap.timeline({
				defaults: { duration: 1 },
				scrollTrigger: {
					trigger: elem,
					scrub: 1,
					start: 'top 40%',
					end: 'bottom 50%',
					markers: false,
				},
			})
				.to(star, {
					duration: 0.01,
					stroke: '#003e52',
					scale: 0.75,
					rotate: -10,
				})
				.to(line, { duration: 0.01, autoAlpha: 1 })
				.from(line, { drawSVG: 0 }, 0)
				.to(
					star,
					{
						motionPath: {
							path: line,
							align: line,
							alignOrigin: [0.5, 0.5],
						},
					},
					0
				)
				.to(star, { duration: 0.01, autoAlpha: 0 });
		});

		// ----- LOTTIE INIT (per-container guard) -----
		gsap.utils.toArray('.lottie').forEach((elem) => {
			// If this container was already initialized, skip
			if (elem.dataset.lottieInit) return;
			elem.dataset.lottieInit = '1';

			// If something previously appended an <svg>, clear it so we don't see doubles
			const priorSvg = elem.querySelector('svg');
			if (priorSvg) priorSvg.remove();

			const path = elem.dataset.json;
			if (!path || typeof lottie === 'undefined') return;

			const animation = lottie.loadAnimation({
				container: elem,
				renderer: 'svg',
				loop: true,
				autoplay: true, // you were playing immediately anyway
				path,
			});

			// Safari sizing fix
			animation.addEventListener('DOMLoaded', function () {
				if (animation?.renderer?.svgElement) {
					animation.renderer.svgElement.style.width = '99.99%';
					setTimeout(() => {
						if (animation?.renderer?.svgElement) {
							animation.renderer.svgElement.style.width = '100%';
						}
					}, 1);
				}
			});
		});
	});
}
